// Device-group identification.
//
// The MLS SDK auto-creates a LOCAL-ONLY "device group" per account on init — it
// carries personal/cross-device state (drafts, notes, read pointers, self
// profile), has NO server-side membership, and must NEVER appear in the
// conversation list. Its conversation id is deterministic with the sentinel
// prefix `0xFF 0xDC` (`ffdc…` in hex, `_9y…` in base64url) — see
// `device_group_id_for` in ping-core. The SDK also tags it `is_device_group:
// true` in `listConversations()`; we additionally key off the id prefix because
// the live `onConversationUpdated` callback only hands us the id (no metadata),
// and a Welcome-joined device group stores no name.
//
// A device-group row leaking into Dexie is the "phantom / false new chat" bug:
// it renders as an empty 1:1 ("New chat", no messages) the user never created.

/** The sentinel prefix for a device-group conversation id, in hex. */
export const DEVICE_GROUP_ID_HEX_PREFIX = 'ffdc';

/**
 * True when `conversationIdHex` is the local-only device group (never a real
 * chat). Accepts a hex string (lower/upper-case). Mirrors the check in
 * `transport-mls/PingTransport.ts`.
 */
export function isDeviceGroupConversationId(conversationIdHex: string): boolean {
  return (
    conversationIdHex.length >= DEVICE_GROUP_ID_HEX_PREFIX.length &&
    conversationIdHex.slice(0, DEVICE_GROUP_ID_HEX_PREFIX.length).toLowerCase() ===
      DEVICE_GROUP_ID_HEX_PREFIX
  );
}
